import * as types from '../mutation-types'

const state = {
  productNo: '' //
}

// getters
const getters = {
  getProductNo: state => state.productNo
}

// actions
const actions = {
  setProductNo ({ commit }, payload) {
    commit(types.PRODUCT_NO, payload)
  }
}

// mutations
const mutations = {
  [types.PRODUCT_NO] (state, status) {
    state.productNo = status
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/product.js